/**
 * Shared category hierarchy limits (root -> leaf).
 * Keep aligned with backend CategoryHierarchyPolicy.
 */
export const MAX_CATEGORY_PATH_SEGMENTS = 5;
export const MAX_CATEGORY_DEPTH = MAX_CATEGORY_PATH_SEGMENTS - 1;
